export const outreachQueryKeys = {
  eventsRoot: ['lead-outreach-events'] as const,
  events: (leadId: string) => [...outreachQueryKeys.eventsRoot, leadId] as const,
  rollupsRoot: ['lead-outreach-rollups'] as const,
  rollups: (leadIds: string[]) => [...outreachQueryKeys.rollupsRoot, leadIds] as const,
  weekQueue: (weekStart: string) => ['week-queue-members', weekStart] as const,
};
